import { render, staticRenderFns } from "./OwnedEarnedPotentialReach.vue?vue&type=template&id=c6142d8c&scoped=true&"
import script from "./OwnedEarnedPotentialReach.vue?vue&type=script&lang=js&"
export * from "./OwnedEarnedPotentialReach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6142d8c",
  null
  
)

export default component.exports